import type { TmWrappers } from '@/wrappers'

export const editVerifyingEmailModalId = 'editVerifyingEmailModal' as TmWrappers

export type EditVerifyingEmailModalParams = {
  email: string
  userId: string
}
